import styled, { keyframes } from 'styled-components';

const animationTypeOpen: Record<string, any> = {
  toLeft: keyframes`{
            0% {transform: translateX(100%);}
            100% {transform: translateX(0);}
            }`,
  toRight: keyframes`{
            0% {transform: translateX(-100%);}
            100% {transform: translateX(0);}
            }`,
  toTop: keyframes`{
            0% {transform: translateY(100%);}
            100% {transform: translateY(0);}
            }`,
  toBottom: keyframes`{
            0% {transform: translateY(-100%);}
            100% {transform: translateY(0);}
            }`
};

const animationTypeClose: Record<string, any> = {
  toLeft: keyframes`{
            0% {transform: translateX(0);}
            100% {transform: translateX(100%);}
            }`,
  toRight: keyframes`{
            0% {transform: translateX(0);}
            100% {transform: translateX(-100%);}
            }`,
  toTop: keyframes`{
            0% {transform: translateY(0);}
            100% {transform: translateY(100%);}
            }`,
  toBottom: keyframes`{
            0% {transform: translateY(0);}
            100% {transform: translateY(-100%);}
            }`
};

export const CustomMask = styled.div<{ maskBackground?: string }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background: ${props =>
    props.maskBackground ? props.maskBackground : 'rgba(0,0,0,0.3)'};
  z-index: 1;
`;

export const Container = styled.div<{
  show: boolean;
  animationTime?: string;
  $maskPosTop?: string;
}>`
  position: fixed;
  height: -webkit-fill-available;
  height: -moz-available;
  height: fill-available;
  top: ${props => (props.$maskPosTop ? props.$maskPosTop : 0)};
  left: 0;
  right: 0;
  opacity: ${props => (props.show ? 1 : 0)};
  z-index: 11;
  pointer-events: ${props => (props.show ? 'all' : 'none')};
  overflow: hidden;
  transition: opacity
    ${props => (props.animationTime ? props.animationTime : '0.3s')};

  ${CustomMask} {
    top: ${props => (props.$maskPosTop ? props.$maskPosTop : 0)};
  }
`;
export const CustomData = styled.div<{
  animationType: string;
  animationTime?: string;
  posTop?: string;
  posBottom?: string;
  posLeft?: string;
  posRight?: string;
}>`
  position: absolute;
  height: 100%;
  bottom: ${props => (props.posBottom ? props.posBottom : 0)};
  top: ${props => (props.posTop ? props.posTop : 0)};
  left: ${props => (props.posLeft ? props.posLeft : 0)};
  right: ${props => (props.posRight ? props.posRight : 0)};
  display: flex;
  flex-direction: column;
  z-index: 3;
  background: var(--v3-black-0);

  &.customPopup--open {
    animation: ${props => animationTypeOpen[props.animationType]}
      ${props => (props.animationTime ? props.animationTime : '0.3s')} ease
      forwards;
  }

  &.customPopup--close {
    animation: ${props => animationTypeClose[props.animationType]}
      ${props => (props.animationTime ? props.animationTime : '0.3s')} ease
      forwards;
  }
`;
